import classNames from 'classnames';
import React, { FC } from 'react';
import styles from './styles.module.css';

type CardType = {
  title?: string;
  id?: string;
  className?: string;
  children?: React.ReactNode;
};

export const Card: FC<CardType> = ({ className, children, title, id }) => {
  return (
    <div className={classNames(styles.container, className)} data-testid={id}>
      {title && <h2>{title}</h2>}
      {children}
    </div>
  );
};
